import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.css';
import Swiper, {Navigation, Pagination, Autoplay, EffectFade} from 'swiper';
import "swiper/swiper-bundle.css";
Swiper.use([Navigation, Pagination, Autoplay, EffectFade]);

$("document").ready(function() {

  if (document.querySelectorAll('.noticeBarBox').length > 0) {
    let dateDayStorage = localStorage.getItem('dateDay');
    let dateTimeStorage = localStorage.getItem('dateTime');

    if (dateDayStorage) {
        console.log('Retrieved from local storage:', dateDayStorage);
        $('.noticeTimer .dateDay').text(dateDayStorage);

    }
    if (dateTimeStorage) {
      console.log('Retrieved from local storage:', dateTimeStorage);
      $('.noticeTimer .dateTime').text(dateTimeStorage);
      $('.noticeTimer').addClass('active');
   }
  }
  if (document.querySelectorAll('.faqBox .greenBtn').length > 0) {
    $('.faqBox .greenBtn').click(function(){
      $(this).parent().parent().parent().parent().toggleClass('active');
      return false;
    });
    $('.faqBack .closeBtn').click(function(){
      $(this).parent().parent().parent().parent().toggleClass('active');
      return false;
    });

  }

  $(window).scroll(function () {
    if ($(window).scrollTop() > 0) {
        $('header').addClass('scrolling');
    } else {
        $('header').removeClass('scrolling');
    }
});
$('.languageSelect .current').click(function () {
  $('.languages').toggle();
  return false;
});


$(".hamburgerIcon #check").change(function() {
  $(".mobileMenu").toggle(this.checked);

  if(this.checked) {
    $("header .logo").addClass('active');
    $(".languageSelect").addClass('active');
  } else {
    $("header .logo").removeClass('active');
    $(".languageSelect").removeClass('active');
  }
});

$(".languageSelect li[class*='wpml-ls-item-']").each(function() {
  const languageCode = $(this).attr("class").match(/wpml-ls-item-(\w{2})/)[1];
  const originalText = $(this).find("a").text();

  $(this).find("a").html(`${originalText} <span>${languageCode}</span>`);
});

if (document.querySelectorAll('.escapelle-clock').length > 0) {
  $("#month").datepicker({
      dateFormat: 'yy. mm. dd.',
      onSelect: function(dateText, inst) {

          datum = $(this).val();



      }
  });
  function getDayName(dayIndex) {
    //const daysOfWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    return daysOfWeek[dayIndex];
  }
  $("#month").datepicker("setDate", null);
  $('.timeInput').click(function() {
    $('.timePopup').toggle();
    return false;
  });
  $('.timeNav a').click(function() {
    var what = $(this).data('target');

    $('.timeNav a').removeClass('active');
    $(this).addClass('active');
    $('.timeTab').hide();
    $('#'+what).show();
    return false;
  });
  $('.timeSelect').click(function() {
    var timeAMPM= $(this).text();
    $('.noticeTimer .dateTime').text(timeAMPM);
    localStorage.setItem('dateTime', timeAMPM);
    //$('.noticeTimer').addClass('active');
    var timeSet = $(this).data('target');
    var AMORPM = '';
    if($(this).parent().parent().parent().attr("id")==="pm") {
      //AMORPM = "PM";
      AMORPM = "";
    } else {
      AMORPM = "";
      //AMORPM = "AM";

    }
    $('.timeInput').addClass("active");
    $('.timePopup').toggle();
    $('.timeSelectValue').data('value',timeSet);
    $('.timeSelectValue').text(timeAMPM+ " "+AMORPM);

    return false;
  });

  let timerInterval;
  let finaleDate = 0;
  let timeLeft = 0;
  let days=0;
  let hours = 0;
  let minutes =0;
  let seconds =0;
  let diff=0;
  $('.calculateTime').click(function() {

    $('.validationError').hide();
    $('.noticeTimer').removeClass('active');
    clearInterval(timerInterval);
    // converting to ISO time
    let dateStr = $('#month').val();
    let calendarStr = $('.timeSelectValue').data('value');
    if(dateStr && calendarStr) {
      let dateConverted = dateStr.replace(/. /g, "-");
      dateConverted = dateConverted.replace('.', "");
      let timeConverted = "T"+$('.timeSelectValue').data('value')+':00.000Z';
      let isoDate = dateConverted + timeConverted;
      let selectedDate = new Date(isoDate);


      let dayName = getDayName(selectedDate.getDay());
      console.log(dayName);
      $('.noticeTimer .dateDay').text(dayName);
      localStorage.setItem('dateDay', dayName);

    //  console.log(selectedDate.getTime());
      let hoursToAdd = 72;

      let currentTime = new Date().getTime();


      if(selectedDate > currentTime) {
        $('.validationError').text(validationErrorFuture);
        $('.validationError').show();
      } else {
        let timeDifference = currentTime - selectedDate.getTime();
        let hoursDifference = timeDifference / (1000 * 60 * 60);
        console.log("HOURS DIFFERENCE "+hoursDifference);
        if (hoursDifference <= 72) {
          timeLeft = (hoursToAdd * 60 * 60 * 1000) - (currentTime - selectedDate.getTime());
          console.log("TIME LEFT "+timeLeft / (1000 * 60 * 60));
          if (timerInterval) {
              clearInterval(timerInterval); // Clear the existing interval

          }
          finaleDate = currentTime + timeLeft;

          clearInterval(timerInterval);
          timer();
          timerInterval = setInterval(timer, 1000);
          $('.noticeTimer').addClass('active');

          let hoursLeft =(timeLeft / (1000 * 60 * 60)).toFixed(1);
          let updatedString = validationSuccess.replace('xx,x', hoursLeft);
          $('.validationError').text(updatedString);
          $('.validationError').show();
        } else {
          $('.validationError').text(validationTimeUp);
          $('.validationError').show();
        }
      }

    } else {
      $('.validationError').text(validationErrorBoth);
      $('.validationError').show();
    }

    return false;
  });

  function timer() {
    //console.log(finaleDate);
    const now = new Date().getTime();


    diff = finaleDate - now;
    if(diff < 0){
        $('.validationError').text(validationTimeUp);
        $('.validationError').show();
        clearInterval(timerInterval);
    }

    days = Math.floor(diff / (1000*60*60*24));
    hours = Math.floor(diff % (1000*60*60*24) / (1000*60*60));
    minutes = Math.floor(diff % (1000*60*60)/ (1000*60));
    seconds = Math.floor(diff % (1000*60) / 1000);

    dayhour = days*24;
    hours <= 9 ? hours = `0${hours}` : hours;

    minutes <= 9 ? minutes = `0${minutes}` : minutes;
    seconds <= 9 ? seconds = `0${seconds}` : seconds;
    const addLeadingZero = (value) => (value < 10 ? `0${value}` : value);

    if(dayhour<24) {
      console.log(hours);
      document.querySelector('#escapelle-hours').textContent = addLeadingZero(hours);;
    } else {
      document.querySelector('#escapelle-hours').textContent = dayhour + parseInt(hours);
    }
    document.querySelector('#escapelle-hours').textContent = dayhour + parseInt(hours);
    document.querySelector('#escapelle-minutes').textContent = minutes;
    document.querySelector('#escapelle-seconds').textContent = seconds;

  }
}

function loadFAQ() {
  var searchedTerm = $('.faq-helper').data('term');
  var searchedText = $('.faq-helper').data('search');
  var searchedCategory = $('.faq-helper').data('category');

  $.ajax({
    type: 'post',
    url: `${window.location.origin}/wp-admin/admin-ajax.php`,

    data: {
      action: 'load_faq',
      searchedTerm: searchedTerm,
      searchedText: searchedText,
      searchedCategory: searchedCategory

    }
  }).done(function (resp) {
    $('#results').html(resp);
    $('.accordionHeader').click(function() {
      $(this).parent().toggleClass('active');
      $(this).parent().find('.accordionContent').slideToggle();


        return false;
    });
  }).fail(function (resp) {

  }).always(function () {

  });

}
if (document.querySelectorAll('.faqNavCarousel').length > 0) {

  $('.filterTrigger').click(function () {
    $(this).toggleClass('active');
    $('.filterBox').toggle();

    return false;
  });
  $('.filterBox a').click(function () {

      if ($(this).hasClass('active')) {
          $(this).removeClass('active');
          $('.faq-helper').data('term', '');
      } else {

          $('.filterBox a').removeClass('active');
          $(this).addClass('active');
          var term = $(this).data('term');
          $('.faq-helper').data('term', term);
      }
      $('.filterTrigger').removeClass('active');
      loadFAQ();
      if($(window).width()<=768){
        $('.filterBox').hide();
      }

      return false;
  });

  $(".searchFaq").click(function () {
    var what = $('.searchForm input').val();
    $('.faq-helper').data('search', what);
    loadFAQ();
    return false;
  });

  let swiperfaqCarousel = new Swiper(".faqNavCarousel", {
    loop: false,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    spaceBetween: 0,
    breakpoints: {
      575: {
        slidesPerView: 1,
        spaceBetween: 0
      },
      700: {
        slidesPerView: 1,
        spaceBetween: 0
      },

      1200: {
        slidesPerView: 3,
        spaceBetween: 0,
        allowTouchMove: false
      }
    }
  });

  let isFirstClick = true;

  const faqSearchRow = document.querySelector('.searchRow')
  // Attach click event listener to the link inside the slide
  document.querySelectorAll('.faqNavCarousel a').forEach(link => {
      link.addEventListener('click', function (event) {
          $('.faqNavCarousel a').removeClass('active');
          link.classList.add('active');
          let taxonomy = link.getAttribute('data-taxonomy');
          $('.faq-helper').data('category', taxonomy);

          if(faqSearchRow && taxonomy === 'all'){
            faqSearchRow.classList.remove('d-none')
          } else {
            faqSearchRow.classList.add('d-none')
          }

          loadFAQ();
          event.preventDefault();

          // Check if it's the first click
          if (isFirstClick) {
              // Destroy the existing Swiper instance
              swiperfaqCarousel.destroy(true, true);
              $('.faqWrapper').addClass("active");

              // Create a new Swiper instance with the updated configuration
              swiperfaqCarousel = new Swiper(".faqNavCarousel", {
                  loop: false,
                  pagination: {
                      el: '.swiper-pagination',
                      clickable: true,
                  },
                  spaceBetween: 0,
                  breakpoints: {
                      575: {
                          slidesPerView: 1,
                          spaceBetween: 0
                      },
                      700: {
                          slidesPerView: 1,
                          spaceBetween: 0
                      },
                      1200: {
                          slidesPerView: 4,
                          spaceBetween: 0,
                          allowTouchMove: false
                      }
                  }
              });

              // Update the flag to indicate that the first click has occurred
              isFirstClick = false;
          }
      });
  });



}


if (document.querySelectorAll('.faqCarousel').length > 0) {


  let swiperfaqCarousel = new Swiper(".faqCarousel", {
    loop: false,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    spaceBetween: 0,
    breakpoints: {
      575: {
        slidesPerView: 1,
        spaceBetween: 0
      },
      700: {
        slidesPerView: 1,
        spaceBetween: 0
      },

      1200: {
        slidesPerView: 2,
        spaceBetween: 0
      }
    }
  });
}
if (document.querySelectorAll('.getSlider').length > 0) {
  let swiperGetSlider = new Swiper(".getSlider", {
    loop: false,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    spaceBetween: 0,
    breakpoints: {
      575: {
        slidesPerView: 1,
        spaceBetween: 0
      },
      700: {
        slidesPerView: 2,
        spaceBetween: 0
      },
      991: {
        slidesPerView: 1,
        spaceBetween: 0
      },
      1200: {
        slidesPerView: 2,
        spaceBetween: 0
      }
    }
  });
}

if ($('.accordion').length > 0) {
    $('.accordionHeader').click(function() {
        $(this).parent().toggleClass('active');
        $(this).parent().find('.accordionContent').slideToggle();


        return false;
    });
}


  $('a[href*="#"]:not([href="#"])').click(function() {
    if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
        if (target.length) {
            $('html, body').animate({
            scrollTop: target.offset().top-100
            }, 1000);
            return false;
        }
      }
    });


  //pharmacy search
  const pharmaciesList = []
  const pharmaciesElements = document.querySelectorAll('.pharmacies-list .pharmacy-row');

  pharmaciesElements.forEach(element => {

    const title = $(element).find('.title').text()
    const address = $(element).find('.address').text()

    pharmaciesList.push({title: title.toLowerCase().trim() + ' ' + address.toLowerCase().trim(), row: element})

  })

  console.log(pharmaciesList)

  $('body').on('click', '.searchPharmacies', function (e) {

    e.preventDefault();

    const form = $(this).closest('.searchForm');
    const input = form.find('input');

    if(!pharmaciesList.length) return;

    const searchName = input.val().toLowerCase();

    pharmaciesList.forEach(item => {
      item.row.classList.add('d-none')

      const hasWord = item.title.search(searchName)

      if(hasWord >= 0) {
        item.row.classList.remove('d-none')
      }

    })

  })

});
